// * To generate pre record "changes" values (encoding, resolution & quality affects max pre record value)
// const generatePreRecordSet = () => {
//     // - Declaring the encoding's, resolution's & quality's API values
//     const encodings = [0, 1];
//     const sizes = [1, 5, 6, 10, 11, 13];
//     const qualities = [0, 1, 2];

//     // - Available list of pre record values and their respective API values
//     const availablePreRecText = [0, 5, 10, 15, 20, 30, 60, 120];
//     const availablePreRecValues = [0, 1, 2, 3, 4, 5, 6, 7];

//     // - Max value to set for H.264-based resolution and quality values for pre record (REFER JIRA TICKET)
//     const maxValues264 = [
//         10, 10, 15, 15, 15, 20, 20, 20, 30, 20, 20, 30, 30, 30, 30, 60, 60, 120
//     ];
//     // - Max value to set for H.265-based resolution and quality values for pre record (REFER JIRA TICKET)
//     const maxValues265 = [
//         20, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 60, 60, 30, 30, 120
//     ];

//     // - Final output holder for the "changes" key
//     let pre_record_changes_values: {
//         toCheck: number[];
//         toSet: number;
//     }[] = [];

//     encodings.forEach((encoding) => {
//         let count = 0;

//         sizes.forEach((size) => {
//             qualities.forEach((quality) => {
//                 // const toSetValues = availablePreRecText.filter((prv) =>
//                 //     encoding === 0
//                 //         ? prv <= maxValues264[count]
//                 //         : prv <= maxValues265[count]
//                 // );

//                 pre_record_changes_values.push({
//                     toCheck: [encoding, size, quality],
//                     toSet:
//                         encoding === 0
//                             ? maxValues264[count]
//                             : maxValues265[count]
//                 });
//                 count++;
//             });
//         });
//     });

//     console.log(pre_record_changes_values);
//     return pre_record_changes_values;
// };

export const pre_record_changes_values_mini = [
    {
        toCheck: [0, 1, 0],
        toSet: 10
    },
    {
        toCheck: [0, 1, 1],
        toSet: 10
    },
    {
        toCheck: [0, 1, 2],
        toSet: 15
    },
    {
        toCheck: [0, 5, 0],
        toSet: 15
    },
    {
        toCheck: [0, 5, 1],
        toSet: 15
    },
    {
        toCheck: [0, 5, 2],
        toSet: 20
    },
    {
        toCheck: [0, 6, 0],
        toSet: 20
    },
    {
        toCheck: [0, 6, 1],
        toSet: 20
    },
    {
        toCheck: [0, 6, 2],
        toSet: 30
    },
    {
        toCheck: [0, 10, 0],
        toSet: 20
    },
    {
        toCheck: [0, 10, 1],
        toSet: 20
    },
    {
        toCheck: [0, 10, 2],
        toSet: 30
    },
    {
        toCheck: [0, 11, 0],
        toSet: 30
    },
    {
        toCheck: [0, 11, 1],
        toSet: 30
    },
    {
        toCheck: [0, 11, 2],
        toSet: 30
    },
    {
        toCheck: [0, 13, 0],
        toSet: 60
    },
    {
        toCheck: [0, 13, 1],
        toSet: 60
    },
    {
        toCheck: [0, 13, 2],
        toSet: 120
    },
    {
        toCheck: [1, 1, 0],
        toSet: 20
    },
    {
        toCheck: [1, 1, 1],
        toSet: 30
    },
    {
        toCheck: [1, 1, 2],
        toSet: 30
    },
    {
        toCheck: [1, 5, 0],
        toSet: 30
    },
    {
        toCheck: [1, 5, 1],
        toSet: 30
    },
    {
        toCheck: [1, 5, 2],
        toSet: 30
    },
    {
        toCheck: [1, 6, 0],
        toSet: 30
    },
    {
        toCheck: [1, 6, 1],
        toSet: 30
    },
    {
        toCheck: [1, 6, 2],
        toSet: 30
    },
    {
        toCheck: [1, 10, 0],
        toSet: 30
    },
    {
        toCheck: [1, 10, 1],
        toSet: 30
    },
    {
        toCheck: [1, 10, 2],
        toSet: 30
    },
    {
        toCheck: [1, 11, 0],
        toSet: 30
    },
    {
        toCheck: [1, 11, 1],
        toSet: 60
    },
    {
        toCheck: [1, 11, 2],
        toSet: 60
    },
    {
        toCheck: [1, 13, 0],
        toSet: 30
    },
    {
        toCheck: [1, 13, 1],
        toSet: 30
    },
    {
        toCheck: [1, 13, 2],
        toSet: 120
    }
];

// * To generate pre record "changes" values (encoding, resolution & quality affects max pre record value)
// const generatePreRecordSet = () => {
//     // - Declaring the encoding's, resolution's & quality's API values
//     const encodings = [0, 1];
//     const sizes = [1, 5, 6, 10, 11, 13];
//     const qualities = [0, 1, 2];

//     // - Available list of pre record values and their respective API values
//     const availablePreRecText = [0, 5, 10, 15, 20, 30, 60, 120];
//     const availablePreRecValues = [0, 1, 2, 3, 4, 5, 6, 7];

//     // - Max value to set for H.264-based resolution and quality values for pre record (REFER JIRA TICKET)
//     const maxValues264 = [
//         10, 15, 15, 10, 15, 20, 20, 20, 30, 30, 30, 30, 30, 30, 30, 60, 60, 120
//     ];
//     // - Max value to set for H.265-based resolution and quality values for pre record (REFER JIRA TICKET)
//     const maxValues265 = [
//         20, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 60, 60, 120, 120,
//         120
//     ];

//     // - Final output holder for the "changes" key
//     let pre_record_changes_values: {
//         toCheck: number[];
//         toSet: number;
//     }[] = [];

//     encodings.forEach((encoding) => {
//         let count = 0;

//         sizes.forEach((size) => {
//             qualities.forEach((quality) => {
//                 // const toSetValues = availablePreRecText.filter((prv) =>
//                 //     encoding === 0
//                 //         ? prv <= maxValues264[count]
//                 //         : prv <= maxValues265[count]
//                 // );

//                 pre_record_changes_values.push({
//                     toCheck: [encoding, size, quality],
//                     toSet:
//                         encoding === 0
//                             ? maxValues264[count]
//                             : maxValues265[count]
//                 });
//                 count++;
//             });
//         });
//     });

//     console.log(pre_record_changes_values);
//     return pre_record_changes_values;
// };

export const pre_record_changes_values_4g = [
    {
        toCheck: [0, 1, 0],
        toSet: 10
    },
    {
        toCheck: [0, 1, 1],
        toSet: 15
    },
    {
        toCheck: [0, 1, 2],
        toSet: 15
    },
    {
        toCheck: [0, 5, 0],
        toSet: 10
    },
    {
        toCheck: [0, 5, 1],
        toSet: 15
    },
    {
        toCheck: [0, 5, 2],
        toSet: 20
    },
    {
        toCheck: [0, 6, 0],
        toSet: 20
    },
    {
        toCheck: [0, 6, 1],
        toSet: 20
    },
    {
        toCheck: [0, 6, 2],
        toSet: 30
    },
    {
        toCheck: [0, 10, 0],
        toSet: 30
    },
    {
        toCheck: [0, 10, 1],
        toSet: 30
    },
    {
        toCheck: [0, 10, 2],
        toSet: 30
    },
    {
        toCheck: [0, 11, 0],
        toSet: 30
    },
    {
        toCheck: [0, 11, 1],
        toSet: 30
    },
    {
        toCheck: [0, 11, 2],
        toSet: 30
    },
    {
        toCheck: [0, 13, 0],
        toSet: 60
    },
    {
        toCheck: [0, 13, 1],
        toSet: 60
    },
    {
        toCheck: [0, 13, 2],
        toSet: 120
    },
    {
        toCheck: [1, 1, 0],
        toSet: 20
    },
    {
        toCheck: [1, 1, 1],
        toSet: 30
    },
    {
        toCheck: [1, 1, 2],
        toSet: 30
    },
    {
        toCheck: [1, 5, 0],
        toSet: 30
    },
    {
        toCheck: [1, 5, 1],
        toSet: 30
    },
    {
        toCheck: [1, 5, 2],
        toSet: 30
    },
    {
        toCheck: [1, 6, 0],
        toSet: 30
    },
    {
        toCheck: [1, 6, 1],
        toSet: 30
    },
    {
        toCheck: [1, 6, 2],
        toSet: 30
    },
    {
        toCheck: [1, 10, 0],
        toSet: 30
    },
    {
        toCheck: [1, 10, 1],
        toSet: 30
    },
    {
        toCheck: [1, 10, 2],
        toSet: 30
    },
    {
        toCheck: [1, 11, 0],
        toSet: 30
    },
    {
        toCheck: [1, 11, 1],
        toSet: 60
    },
    {
        toCheck: [1, 11, 2],
        toSet: 60
    },
    {
        toCheck: [1, 13, 0],
        toSet: 120
    },
    {
        toCheck: [1, 13, 1],
        toSet: 120
    },
    {
        toCheck: [1, 13, 2],
        toSet: 120
    }
];

// * To generate pre record "changes" values (encoding, resolution & quality affects max pre record value)
// const generatePreRecordSet = () => {
//     // - Declaring the encoding's, resolution's & quality's API values
//     const encodings = [0, 1];
//     const sizes = [1, 5, 6, 10, 11, 13];
//     const qualities = [0, 1, 2];

//     // - Available list of pre record values and their respective API values
//     const availablePreRecText = [0, 5, 10, 15, 20, 30, 60, 120];
//     const availablePreRecValues = [0, 1, 2, 3, 4, 5, 6, 7];

//     // - Max value to set for H.264-based resolution and quality values for pre record (REFER JIRA TICKET)
//     const maxValues264 = [
//         10, 10, 10, 20, 30, 30, 30, 30, 60, 30, 30, 60, 30, 30, 30, 120, 120,
//         120
//     ];
//     // - Max value to set for H.265-based resolution and quality values for pre record (REFER JIRA TICKET)
//     const maxValues265 = [
//         20, 30, 30, 20, 30, 30, 30, 60, 60, 30, 30, 60, 60, 60, 60, 120, 120,
//         120
//     ];

//     // - Final output holder for the "changes" key
//     let pre_record_changes_values: {
//         toCheck: number[];
//         toSet: number;
//     }[] = [];

//     encodings.forEach((encoding) => {
//         let count = 0;

//         sizes.forEach((size) => {
//             qualities.forEach((quality) => {
//                 // const toSetValues = availablePreRecText.filter((prv) =>
//                 //     encoding === 0
//                 //         ? prv <= maxValues264[count]
//                 //         : prv <= maxValues265[count]
//                 // );

//                 pre_record_changes_values.push({
//                     toCheck: [encoding, size, quality],
//                     toSet:
//                         encoding === 0
//                             ? maxValues264[count]
//                             : maxValues265[count]
//                 });
//                 count++;
//             });
//         });
//     });

//     console.log(pre_record_changes_values);
//     return pre_record_changes_values;
// };

export const pre_record_changes_values_2plus = [
    {
        toCheck: [0, 1, 0],
        toSet: 10
    },
    {
        toCheck: [0, 1, 1],
        toSet: 10
    },
    {
        toCheck: [0, 1, 2],
        toSet: 10
    },
    {
        toCheck: [0, 5, 0],
        toSet: 20
    },
    {
        toCheck: [0, 5, 1],
        toSet: 30
    },
    {
        toCheck: [0, 5, 2],
        toSet: 30
    },
    {
        toCheck: [0, 6, 0],
        toSet: 30
    },
    {
        toCheck: [0, 6, 1],
        toSet: 30
    },
    {
        toCheck: [0, 6, 2],
        toSet: 60
    },
    {
        toCheck: [0, 10, 0],
        toSet: 30
    },
    {
        toCheck: [0, 10, 1],
        toSet: 30
    },
    {
        toCheck: [0, 10, 2],
        toSet: 60
    },
    {
        toCheck: [0, 11, 0],
        toSet: 30
    },
    {
        toCheck: [0, 11, 1],
        toSet: 30
    },
    {
        toCheck: [0, 11, 2],
        toSet: 30
    },
    {
        toCheck: [0, 13, 0],
        toSet: 120
    },
    {
        toCheck: [0, 13, 1],
        toSet: 120
    },
    {
        toCheck: [0, 13, 2],
        toSet: 120
    },
    {
        toCheck: [1, 1, 0],
        toSet: 20
    },
    {
        toCheck: [1, 1, 1],
        toSet: 30
    },
    {
        toCheck: [1, 1, 2],
        toSet: 30
    },
    {
        toCheck: [1, 5, 0],
        toSet: 20
    },
    {
        toCheck: [1, 5, 1],
        toSet: 30
    },
    {
        toCheck: [1, 5, 2],
        toSet: 30
    },
    {
        toCheck: [1, 6, 0],
        toSet: 30
    },
    {
        toCheck: [1, 6, 1],
        toSet: 60
    },
    {
        toCheck: [1, 6, 2],
        toSet: 60
    },
    {
        toCheck: [1, 10, 0],
        toSet: 30
    },
    {
        toCheck: [1, 10, 1],
        toSet: 30
    },
    {
        toCheck: [1, 10, 2],
        toSet: 60
    },
    {
        toCheck: [1, 11, 0],
        toSet: 60
    },
    {
        toCheck: [1, 11, 1],
        toSet: 60
    },
    {
        toCheck: [1, 11, 2],
        toSet: 60
    },
    {
        toCheck: [1, 13, 0],
        toSet: 120
    },
    {
        toCheck: [1, 13, 1],
        toSet: 120
    },
    {
        toCheck: [1, 13, 2],
        toSet: 120
    }
];
